import { render, staticRenderFns } from "./InviteCard.vue?vue&type=template&id=70b3272e&scoped=true&"
import script from "./InviteCard.vue?vue&type=script&lang=js&"
export * from "./InviteCard.vue?vue&type=script&lang=js&"
import style0 from "./InviteCard.vue?vue&type=style&index=0&id=70b3272e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3272e",
  null
  
)

export default component.exports